import axios from "axios";

export const useCorridorPublicAPI = () => {
        return axios.create({
                baseURL: import.meta.env.VITE_RESTAPI_URL ?? `https://${window.location.hostname}/api/v2`,
                headers: { "Content-Type": "application/json", "x-api-key": import.meta.env.VITE_X_API_KEY },
                // withCredentials: true, // We're not currently using this
                // withXSRFToken: true, // We're not currently using XSRF
        });
};
